// extracted by mini-css-extract-plugin
export default {"invisibleTitle":"AnnualReportContentLoading_invisibleTitle__wKlBU","articleContent":"AnnualReportContentLoading_articleContent__MUVJ3"};